(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pst-hero"] && !window.DesignMode) return;
  try {
    
  class PSTHeroSlideshow extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.pst-hero-slider');
      this.slideshow = this.closest('.pst-hero__slideshow');
      this.prevButton = this.slideshow.querySelector('.pst-hero-button--prev');
      this.nextButton = this.slideshow.querySelector('.pst-hero-button--next');
      this.sliderDots = this.slideshow.querySelectorAll('.pst-hero-counter__dot');
      this.slides = this.querySelectorAll('.pst-hero-slide');
      this.autoRotateInterval = 5000; // 5 seconds
      this.timer = null;

      this.initSlider();
    }

    initSlider() {
      if (!this.slider || this.slides.length === 0) return;

      this.currentSlide = 0;
      this.slides[0].classList.add('active');

      if (this.prevButton) {
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
      }

      this.sliderDots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.setSlide(index));
      });

      // Start auto-rotation only if we have slides
      if (this.slides.length > 1) {
        this.startAutoRotate();
      }

      // Pause on hover or focus
      this.slideshow.addEventListener('mouseenter', () => this.pauseAutoRotate());
      this.slideshow.addEventListener('mouseleave', () => this.startAutoRotate());
      this.slideshow.addEventListener('focusin', () => this.pauseAutoRotate());
      this.slideshow.addEventListener('focusout', () => this.startAutoRotate());

      this.updateSlidePositions();
    }

    startAutoRotate() {
      if (this.slides.length <= 1) return;

      this.pauseAutoRotate(); // Clear any existing timer
      this.timer = setInterval(() => {
        const nextIndex = (this.currentSlide + 1) % this.slides.length;
        this.slides[this.currentSlide].classList.remove('active');
        this.slides[this.currentSlide].classList.add('previous');
        this.setSlide(nextIndex);
      }, this.autoRotateInterval);
    }

    pauseAutoRotate() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    onButtonClick(event) {
      event.preventDefault();
      this.pauseAutoRotate(); // Pause on manual navigation

      const isNext = event.currentTarget.name === 'next';
      const oldIndex = this.currentSlide;

      if (isNext) {
        this.currentSlide = (this.currentSlide + 1) % this.slides.length;
      } else {
        this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
      }

      // Remove active class from old slide
      this.slides[oldIndex].classList.remove('active');

      // Add the appropriate transition class based on direction
      if (isNext) {
        this.slides[oldIndex].classList.add('previous');
      } else {
        // For previous direction, the new slide comes from the left
        this.slides[this.currentSlide].style.transform = 'translateX(-100%)';
      }

      this.setSlide(this.currentSlide);

      // Restart auto-rotation after a brief delay
      setTimeout(() => this.startAutoRotate(), 10000);
    }

    setSlide(index) {
      this.slides.forEach((slide) => {
        slide.classList.remove('active', 'previous');
        slide.style.transform = '';
      });

      this.slides[index].classList.add('active');

      this.sliderDots.forEach((dot, i) => {
        dot.classList.toggle('pst-hero-counter__dot--active', i === index);
      });

      this.currentSlide = index;
      this.updateSlidePositions();
    }

    updateSlidePositions() {
      this.slides.forEach((slide, i) => {
        if (i === this.currentSlide) {
          slide.style.transform = 'translateX(0)';
          slide.style.opacity = '1';
          slide.style.zIndex = '1';
        } else if (i < this.currentSlide) {
          slide.style.transform = 'translateX(-100%)';
          slide.style.opacity = '0';
          slide.style.zIndex = '0';
        } else {
          slide.style.transform = 'translateX(100%)';
          slide.style.opacity = '0';
          slide.style.zIndex = '0';
        }
      });
    }
  }

  customElements.define('pst-hero-slideshow', PSTHeroSlideshow);

  } catch(e) { console.error(e); }
})();
})();
